var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333984,
    width: 56,
    height: 56,
    rx: 20,
    fill: "#171717",
    fillOpacity: 0.03
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9273 19.9401C26.0177 19.3976 26.487 19 27.037 19H29.6309C30.1809 19 30.6502 19.3976 30.7406 19.9401L30.9541 21.2211C31.0165 21.5951 31.2664 21.9067 31.5982 22.0904C31.6724 22.1314 31.7457 22.1738 31.8181 22.2176C32.1432 22.4138 32.5385 22.4749 32.8941 22.3417L34.1109 21.8858C34.6259 21.6928 35.2049 21.9005 35.4799 22.3768L36.7769 24.6232C37.0518 25.0995 36.9422 25.7047 36.5176 26.0543L35.5133 26.8811C35.2207 27.1219 35.0757 27.4937 35.0828 27.8725C35.0835 27.9149 35.0839 27.9574 35.0839 28C35.0839 28.0426 35.0835 28.0851 35.0828 28.1275C35.0757 28.5063 35.2207 28.8781 35.5133 29.1189L36.5176 29.9457C36.9422 30.2953 37.0518 30.9005 36.7769 31.3768L35.4799 33.6232C35.2049 34.0995 34.6259 34.3071 34.1109 34.1142L32.8941 33.6583C32.5385 33.5251 32.1432 33.5862 31.8181 33.7824C31.7457 33.8262 31.6724 33.8686 31.5982 33.9096C31.2664 34.0933 31.0165 34.4049 30.9541 34.7789L30.7406 36.0599C30.6502 36.6024 30.1809 37 29.6309 37H27.037C26.487 37 26.0177 36.6024 25.9273 36.0599L25.7138 34.7789C25.6514 34.4049 25.4014 34.0933 25.0697 33.9096C24.9955 33.8686 24.9222 33.8262 24.8498 33.7824C24.5247 33.5862 24.1294 33.5251 23.7738 33.6583L22.557 34.1142C22.042 34.3072 21.463 34.0995 21.188 33.6232L19.891 31.3768C19.616 30.9005 19.7257 30.2953 20.1503 29.9457L21.1546 29.1189C21.4471 28.8781 21.5921 28.5063 21.5851 28.1275C21.5843 28.0851 21.5839 28.0426 21.5839 28C21.5839 27.9574 21.5843 27.9149 21.5851 27.8725C21.5921 27.4937 21.4471 27.1219 21.1546 26.8811L20.1503 26.0543C19.7257 25.7047 19.616 25.0995 19.891 24.6232L21.188 22.3768C21.463 21.9005 22.042 21.6929 22.557 21.8858L23.7738 22.3417C24.1294 22.4749 24.5247 22.4138 24.8497 22.2176C24.9222 22.1738 24.9955 22.1314 25.0697 22.0904C25.4014 21.9067 25.6514 21.5951 25.7138 21.2211L25.9273 19.9401Z",
    stroke: "#46494B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3337 27.9999C31.3337 29.6568 29.9906 30.9999 28.3337 30.9999C26.6769 30.9999 25.3337 29.6568 25.3337 27.9999C25.3337 26.3431 26.6769 24.9999 28.3337 24.9999C29.9906 24.9999 31.3337 26.3431 31.3337 27.9999Z",
    stroke: "#46494B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.6d65fbbbab150974bd3e03569a02e46c.svg";
export { ForwardRef as ReactComponent };